// Mock data for Sabey Logistics

export const customers = [
  { name: 'Amazon', logo: 'https://logo.clearbit.com/amazon.com' },
  { name: 'Alcatel Lucent', logo: 'https://logo.clearbit.com/nokia.com' },
  { name: 'Applied Materials', logo: 'https://logo.clearbit.com/appliedmaterials.com' },
  { name: 'Arista Networks', logo: 'https://logo.clearbit.com/arista.com' },
  { name: 'ASML', logo: 'https://logo.clearbit.com/asml.com' },
  { name: 'AT&T', logo: 'https://logo.clearbit.com/att.com' },
  { name: 'Avant', logo: 'https://logo.clearbit.com/avant.com' },
  { name: 'Abbott Laboratories', logo: 'https://logo.clearbit.com/abbott.com' },
  { name: 'Advance Auto Parts', logo: 'https://logo.clearbit.com/advanceautoparts.com' },
  { name: 'ArcBest', logo: 'https://logo.clearbit.com/arcb.com' },
  { name: 'Beavex', logo: 'https://logo.clearbit.com/beavex.com' },
  { name: 'BD Bio Sciences', logo: 'https://logo.clearbit.com/bd.com' },
  { name: 'BD Diagnostics', logo: 'https://logo.clearbit.com/bd.com' },
  { name: 'Becton Dickinson', logo: 'https://logo.clearbit.com/bd.com' },
  { name: 'Boeing', logo: 'https://logo.clearbit.com/boeing.com' },
  { name: 'Baxter International', logo: 'https://logo.clearbit.com/baxter.com' },
  { name: 'Broadcom', logo: 'https://logo.clearbit.com/broadcom.com' },
  { name: 'Brocade', logo: 'https://logo.clearbit.com/broadcom.com' },
  { name: 'Burroughs', logo: 'https://logo.clearbit.com/burroughs.com' },
  { name: 'Burroughs Tidel', logo: 'https://logo.clearbit.com/burroughs.com' },
  { name: 'Carestream', logo: 'https://logo.clearbit.com/carestream.com' },
  { name: 'Cardinal Health', logo: 'https://logo.clearbit.com/cardinalhealth.com' },
  { name: 'CEVA Logistics', logo: 'https://logo.clearbit.com/cevalogistics.com' },
  { name: 'Check Point Software', logo: 'https://logo.clearbit.com/checkpoint.com' },
  { name: 'Cisco Systems', logo: 'https://logo.clearbit.com/cisco.com' },
  { name: 'Ciena', logo: 'https://logo.clearbit.com/ciena.com' },
  { name: 'Computacenter', logo: 'https://logo.clearbit.com/computacenter.com' },
  { name: 'Comcast', logo: 'https://logo.clearbit.com/comcast.com' },
  { name: 'CompuCom', logo: 'https://logo.clearbit.com/compucom.com' },
  { name: 'Costco', logo: 'https://logo.clearbit.com/costco.com' },
  { name: 'CDW', logo: 'https://logo.clearbit.com/cdw.com' },
  { name: 'CTDI', logo: 'https://logo.clearbit.com/ctdi.com' },
  { name: 'DataDirect', logo: 'https://logo.clearbit.com/datadirect.com' },
  { name: 'Decision One', logo: 'https://logo.clearbit.com/decisionone.com' },
  { name: 'Dell', logo: 'https://logo.clearbit.com/dell.com' },
  { name: 'Diebold', logo: 'https://logo.clearbit.com/dieboldnixdorf.com' },
  { name: 'Diebold Nixdorf', logo: 'https://logo.clearbit.com/dieboldnixdorf.com' },
  { name: 'DB Schenker', logo: 'https://logo.clearbit.com/dbschenker.com' },
  { name: 'EMC', logo: 'https://logo.clearbit.com/dell.com' },
  { name: 'Equant', logo: 'https://logo.clearbit.com/orange.com' },
  { name: 'Essential', logo: 'https://logo.clearbit.com/essential.com' },
  { name: 'Extreme', logo: 'https://logo.clearbit.com/extremenetworks.com' },
  { name: 'Elo Touch Solutions', logo: 'https://logo.clearbit.com/elotouch.com' },
  { name: 'F5 Networks', logo: 'https://logo.clearbit.com/f5.com' },
  { name: 'Flex', logo: 'https://logo.clearbit.com/flex.com' },
  { name: 'Foxconn', logo: 'https://logo.clearbit.com/foxconn.com' },
  { name: 'Fortinet', logo: 'https://logo.clearbit.com/fortinet.com' },
  { name: 'GE HealthCare', logo: 'https://logo.clearbit.com/gehealthcare.com' },
  { name: 'GXO Logistics', logo: 'https://logo.clearbit.com/gxo.com' },
  { name: 'Glory Global Solutions', logo: 'https://logo.clearbit.com/glory-global.com' },
  { name: 'Grainger', logo: 'https://logo.clearbit.com/grainger.com' },
  { name: 'Graybar', logo: 'https://logo.clearbit.com/graybar.com' },
  { name: 'HPE', logo: 'https://logo.clearbit.com/hpe.com' },
  { name: 'HP Inc', logo: 'https://logo.clearbit.com/hp.com' },
  { name: 'Hitachi', logo: 'https://logo.clearbit.com/hitachi.com' },
  { name: 'Hyosung', logo: 'https://logo.clearbit.com/hyosung.com' },
  { name: 'IBM', logo: 'https://logo.clearbit.com/ibm.com' },
  { name: 'Ingenico', logo: 'https://logo.clearbit.com/ingenico.com' },
  { name: 'Insight Enterprises', logo: 'https://logo.clearbit.com/insight.com' },
  { name: 'Iron Mountain', logo: 'https://logo.clearbit.com/ironmountain.com' },
  { name: 'Jabil', logo: 'https://logo.clearbit.com/jabil.com' },
  { name: 'Juniper Networks', logo: 'https://logo.clearbit.com/juniper.net' },
  { name: 'KLA Corporation', logo: 'https://logo.clearbit.com/kla.com' },
  { name: 'Kodak', logo: 'https://logo.clearbit.com/kodak.com' },
  { name: 'Kuehne + Nagel', logo: 'https://logo.clearbit.com/kuehne-nagel.com' },
  { name: 'Lam Research', logo: 'https://logo.clearbit.com/lamresearch.com' },
  { name: 'Level3', logo: 'https://logo.clearbit.com/lumen.com' },
  { name: 'Level3 CenturyLink', logo: 'https://logo.clearbit.com/lumen.com' },
  { name: 'Lineage Logistics', logo: 'https://logo.clearbit.com/lineagelogistics.com' },
  { name: 'Makino', logo: 'https://logo.clearbit.com/makino.com' },
  { name: 'Marken', logo: 'https://logo.clearbit.com/marken.com' },
  { name: 'McKesson', logo: 'https://logo.clearbit.com/mckesson.com' },
  { name: 'Mellanox', logo: 'https://logo.clearbit.com/nvidia.com' },
  { name: 'MNX', logo: 'https://logo.clearbit.com/mnxglobal.com' },
  { name: 'Molex', logo: 'https://logo.clearbit.com/molex.com' },
  { name: 'Motion Industries', logo: 'https://logo.clearbit.com/motionindustries.com' },
  { name: 'Maersk Logistics', logo: 'https://logo.clearbit.com/maersk.com' },
  { name: 'NACR', logo: 'https://logo.clearbit.com/nacr.com' },
  { name: 'NAPA', logo: 'https://logo.clearbit.com/napaonline.com' },
  { name: 'NetApp', logo: 'https://logo.clearbit.com/netapp.com' },
  { name: 'Network Appliance', logo: 'https://logo.clearbit.com/netapp.com' },
  { name: 'NetworkCraze', logo: 'https://logo.clearbit.com/networkcraze.com' },
  { name: 'NxStage', logo: 'https://logo.clearbit.com/nxstage.com' },
  { name: 'NCR Atleos', logo: 'https://logo.clearbit.com/ncr.com' },
  { name: 'NCR Voyix', logo: 'https://logo.clearbit.com/ncr.com' },
  { name: "O'Reilly Auto Parts", logo: 'https://logo.clearbit.com/oreillyauto.com' },
  { name: 'Park Place Technologies', logo: 'https://logo.clearbit.com/parkplacetech.com' },
  { name: 'Palo Alto Networks', logo: 'https://logo.clearbit.com/paloaltonetworks.com' },
  { name: 'Penske Logistics', logo: 'https://logo.clearbit.com/penskelogistics.com' },
  { name: 'Philips HealthCare', logo: 'https://logo.clearbit.com/philips.com' },
  { name: 'Philips Medical', logo: 'https://logo.clearbit.com/philips.com' },
  { name: 'PMPS', logo: 'https://logo.clearbit.com/pmps.com' },
  { name: 'Presidio', logo: 'https://logo.clearbit.com/presidio.com' },
  { name: 'Riverbed', logo: 'https://logo.clearbit.com/riverbed.com' },
  { name: 'Ruckus', logo: 'https://logo.clearbit.com/ruckusnetworks.com' },
  { name: 'Ryder Supply Chain', logo: 'https://logo.clearbit.com/ryder.com' },
  { name: 'Sagnet', logo: 'https://logo.clearbit.com/sagnet.com' },
  { name: 'Schneider', logo: 'https://logo.clearbit.com/schneider.com' },
  { name: 'Schneider Electric', logo: 'https://logo.clearbit.com/se.com' },
  { name: 'SHI International', logo: 'https://logo.clearbit.com/shi.com' },
  { name: 'Siemens Healthineers', logo: 'https://logo.clearbit.com/siemens-healthineers.com' },
  { name: 'Smith & Nephew', logo: 'https://logo.clearbit.com/smith-nephew.com' },
  { name: 'Smiths Detection', logo: 'https://logo.clearbit.com/smithsdetection.com' },
  { name: 'Sony', logo: 'https://logo.clearbit.com/sony.com' },
  { name: 'Stoneside', logo: 'https://logo.clearbit.com/stoneside.com' },
  { name: 'Stryker', logo: 'https://logo.clearbit.com/stryker.com' },
  { name: 'Supermicro', logo: 'https://logo.clearbit.com/supermicro.com' },
  { name: 'TE Connectivity', logo: 'https://logo.clearbit.com/te.com' },
  { name: 'Tolt', logo: 'https://logo.clearbit.com/tolt.com' },
  { name: 'Tokyo Electron', logo: 'https://logo.clearbit.com/tel.com' },
  { name: 'UPS', logo: 'https://logo.clearbit.com/ups.com' },
  { name: 'Ubiquiti', logo: 'https://logo.clearbit.com/ui.com' },
  { name: 'Unisys', logo: 'https://logo.clearbit.com/unisys.com' },
  { name: 'Verifone', logo: 'https://logo.clearbit.com/verifone.com' },
  { name: 'Verizon', logo: 'https://logo.clearbit.com/verizon.com' },
  { name: 'Viasat', logo: 'https://logo.clearbit.com/viasat.com' },
  { name: 'World Courier', logo: 'https://logo.clearbit.com/worldcourier.com' },
  { name: 'Worldpac', logo: 'https://logo.clearbit.com/worldpac.com' },
  { name: 'World Wide Technology', logo: 'https://logo.clearbit.com/wwt.com' },
  { name: 'Xerox', logo: 'https://logo.clearbit.com/xerox.com' },
  { name: 'XPO Logistics', logo: 'https://logo.clearbit.com/xpo.com' },
  { name: 'Zones', logo: 'https://logo.clearbit.com/zones.com' },
  { name: 'Zimmer Biomet', logo: 'https://logo.clearbit.com/zimmerbiomet.com' },
  { name: 'TSA', logo: 'https://logo.clearbit.com/tsa.gov' },
  { name: 'Canon Solutions', logo: 'https://logo.clearbit.com/csa.canon.com' },
  { name: 'Canon Medical', logo: 'https://logo.clearbit.com/us.medical.canon' },
  { name: 'Flock Safety', logo: 'https://logo.clearbit.com/flocksafety.com' },
  { name: 'DDN1', logo: 'https://logo.clearbit.com/ddn.com' },
  { name: 'DDN2', logo: 'https://logo.clearbit.com/ddn.com' },
  { name: 'Tintri', logo: 'https://logo.clearbit.com/tintri.com' },
  { name: 'MDSI', logo: 'https://logo.clearbit.com/mdsglobal.com' },
  { name: 'Infinera', logo: 'https://logo.clearbit.com/infinera.com' },
  { name: 'Taylyst', logo: 'https://logo.clearbit.com/taylyst.com' },
  { name: 'FedEx', logo: 'https://logo.clearbit.com/fedex.com' },
  { name: 'DHL', logo: 'https://logo.clearbit.com/dhl.com' },
  { name: 'Nvidia', logo: 'https://logo.clearbit.com/nvidia.com' },
  { name: 'ChargePoint', logo: 'https://logo.clearbit.com/chargepoint.com' },
  { name: 'DDN3', logo: 'https://logo.clearbit.com/ddn.com' },
  { name: 'Intel', logo: 'https://logo.clearbit.com/intel.com' },
  { name: 'Ericsson', logo: 'https://logo.clearbit.com/ericsson.com' },
  { name: 'FiberLight', logo: 'https://logo.clearbit.com/fiberlight.com' },
  { name: 'Intuitive Surgical', logo: 'https://logo.clearbit.com/intuitive.com' },
  { name: 'Confluence Health', logo: 'https://logo.clearbit.com/confluencehealth.org' },
  { name: 'U.S. Army', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/United_States_Department_of_the_Army_Seal.svg/240px-United_States_Department_of_the_Army_Seal.svg.png' },
  { name: 'U.S. Navy', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Flag_of_the_United_States_Navy.svg/240px-Flag_of_the_United_States_Navy.svg.png' },
  { name: 'U.S. Air Force', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/USAF_logo.svg/240px-USAF_logo.svg.png' },
  { name: 'FBI', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Seal_of_the_Federal_Bureau_of_Investigation.svg/240px-Seal_of_the_Federal_Bureau_of_Investigation.svg.png' },
  { name: 'U.S. Government', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Great_Seal_of_the_United_States_%28obverse%29.svg/240px-Great_Seal_of_the_United_States_%28obverse%29.svg.png' },
  { name: 'U.S. CBP', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/US-CustomsAndBorderProtection-Seal.svg/240px-US-CustomsAndBorderProtection-Seal.svg.png' }
];

export const services = [
  {
    id: 1,
    title: 'Field Stocking Locations',
    description: 'Strategic FSL locations across the United States ensuring rapid deployment and reduced lead times for critical inventory.',
    icon: 'Warehouse'
  },
  {
    id: 2,
    title: 'Supply Chain Management',
    description: 'End-to-end supply chain solutions optimizing efficiency, reducing costs, and improving visibility across your entire network.',
    icon: 'TrendingUp'
  },
  {
    id: 3,
    title: 'Warehousing & Fulfillment',
    description: 'State-of-the-art warehousing facilities with advanced inventory management and order fulfillment capabilities.',
    icon: 'Package'
  },
  {
    id: 4,
    title: 'Rush Delivery Services',
    description: 'Time-critical delivery solutions with guaranteed on-time performance for your most urgent shipments.',
    icon: 'Zap'
  },
  {
    id: 5,
    title: 'HAZMAT Services',
    description: 'Certified hazardous materials handling and transportation with full DOT compliance and specialized safety protocols.',
    icon: 'AlertTriangle'
  },
  {
    id: 6,
    title: 'TSA Certified Operations',
    description: 'Fully TSA certified with enhanced security protocols for sensitive and regulated shipments.',
    icon: 'Shield'
  },
  {
    id: 7,
    title: 'International Shipping',
    description: 'Global shipping solutions connecting your business to markets worldwide with reliable air freight services.',
    icon: 'Globe'
  }
];

export const stats = [
  { label: 'Orders Delivered', value: '8M+' },
  { label: 'Satisfied Customers', value: '140+' },
  { label: 'US Coverage', value: 'Nationwide' },
  { label: 'On-Time Delivery', value: '99.8%' }
];

export const trackingResults = {
  'SBYL123456789': {
    trackingNumber: 'SBYL123456789',
    status: 'In Transit',
    location: 'Chicago, IL Distribution Center',
    estimatedDelivery: '2025-01-15',
    events: [
      { date: '2025-01-13 14:30', location: 'Chicago, IL', status: 'In Transit', description: 'Package is on the way' },
      { date: '2025-01-13 08:15', location: 'Indianapolis, IN', status: 'Departed Facility', description: 'Left Indianapolis hub' },
      { date: '2025-01-12 22:45', location: 'Indianapolis, IN', status: 'Arrived at Facility', description: 'Arrived at sorting facility' },
      { date: '2025-01-12 16:20', location: 'Columbus, OH', status: 'Picked Up', description: 'Package picked up from shipper' }
    ]
  }
};

export const contactInfo = {
  phone: '1-844-425-2446',
  email: 'controltower@sabeylogistics.com',
  address: '1021 Andover Park E, Tukwila, WA 98188',
  hours: '24/7/365'
};